export const title_bar_title = "Billing Party"

export const billingPartyHeaders = {
    branch_name : "Branch Name",
    branch_code : "Code" ,
    industry : "Industry" ,
    created_by : "Created By" ,
    created_on : "Created On" ,
    modified_by : "Modified By",
    modified_on : "Modified On" ,
    actions : "Edit / Delete"
}

export const fields = {
    billing_party_code : {
        title : "Billing Party Code"
    },
    billing_party_name : {
        title : "Billing Party Name"
    },
    email : {
        title : "Email"
    },
    mobile : {
        title : "Mobile No"
    },
    address : {
        title : "Address"
    },
    pincode : {
        title : "Billing Party Pincode"
    },
    customer_type : {
        title : "Customer Type"
    },
    industry : {
        title : "Industry"
    },
    credit_period : {
        title : "Credit Period"
    },
    contact_person : {
        title : "Contact Person"
    },
    pan_number : {
        title : "Pan Number"
    }
}

export const buttons = {
    close : "Close",
    save : "Save"
}

export const import_title = "Billing Party"